import { render, staticRenderFns } from "./EditorPart.vue?vue&type=template&id=4c38aa95&scoped=true&"
import script from "./EditorPart.vue?vue&type=script&lang=ts&"
export * from "./EditorPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38aa95",
  null
  
)

export default component.exports